<template>
    <div>
        <div class="container-fluid white-bg centers-list fr-page">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <h1 class="zagolovok">Попробовать бесплатно</h1>
                        <p class="text-center">Выберите направление для ребенка для просмотра ознакомительных уроков и
                            записи на установочную сессию с преподавателем:</p>
                    </div>
                </div>

                <div class="row justify-content-center">
                    <study-list-item v-for="item in studyProducts"
                                     :key="item.idstudyproduct"
                                     :studyProduct="item"
                                     @click.native="toStudyProductFreeOrder(item)"
                    />
                </div>
            </div>
        </div>
        <entry/>
    </div>
</template>

<script>
    import StudyListItem from "./StudyListItem";
    import studyProductApi from "../../data/StudyProductApi";
    import Entry from "../Entry";

    export default {
        name: "StudyList",
        components: {StudyListItem, Entry},
        data() {
            return {
                studyProducts: [],
                loading: false,
                error: null,
            }
        },
        mounted() {
            this.loading = true
            studyProductApi.fetchStudyProducts()
                .then(response => {
                    this.studyProducts = response
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })
        },
        methods: {
            toStudyProductFreeOrder(studyProduct) {
                //Отправляем пользователя на покупку бесплатного абонемента направления
                for (let sub of studyProduct.subscriptions) {
                    if (parseInt(sub.price) === 0) {
                        this.$router.push('/subscription/order/' + sub.idsubscription)
                        return
                    }
                }
            }
        }

    }
</script>

<style scoped>
    .zagolovok {
        text-align: center;
        font-family: Manrope Black;
        font-size: 36px !important;
    }
</style>
